module.exports = __webpack_public_path__ + "img/cd-madrigal-ave-maria.dd94b9ec.jpg";